import { gql } from '@apollo/client';

export const ALL_FUNDER_INTERVENTIONS_FOR_SELECT_INPUT = gql`
  query AllFunderInterventions($input: ExportArgs) {
    interventions: funderInterventions(input: $input) {
      id
      name
    }
  }
`;
